import { MyPvControllerDto } from 'src/Libs/flow/installation/api'
import { getUuid } from '../../../utils/get-uuid'
import { parseControllerDevice } from '../device-parsers'
import { BoostConfig, MyPvIo } from 'src/Libs/flow/installation/forms'
import { getMyPvIoBoostTimeFromDto, getMyPvIoBoostTimeToDto } from 'src/Libs/flow/installation/utils'

/** Dto to form MyPV */
export const parseMyPvIo = (io: Nullable<MyPvControllerDto>): MyPvIo => {
  return {
    ...parseControllerDevice(io),

    optimizationMode: io.parameters?.controlMode ?? 'All',
    boostConfig: parseControllerDtoBoostConfigToMyPvBoostConfig(io.parameters?.boostConfig ?? []),
    rawData: io,
  }
}

const parseControllerDtoBoostConfigToMyPvBoostConfig = (boostConfig: MyPvControllerDto['parameters']['boostConfig']): BoostConfig => {
  if (!boostConfig.length) return []

  return boostConfig.map(boost => {
    const days = boost.day?.split(';').map(day => day === '1')
    return {
      id: getUuid(),
      securityTemperature: boost.minTempC || 0,
      fromTime: getMyPvIoBoostTimeFromDto(boost.from ?? '0:00'),
      toTime: getMyPvIoBoostTimeFromDto(boost.to ?? '23:59'),
      weekDays: {
        monday: days?.[0] ?? false,
        tuesday: days?.[1] ?? false,
        wednesday: days?.[2] ?? false,
        thursday: days?.[3] ?? false,
        friday: days?.[4] ?? false,
        saturday: days?.[5] ?? false,
        sunday: days?.[6] ?? false,
      },
    }
  })
}

const parseMyPvBoostConfigToControllerDtoBoostConfig = (boostConfig: BoostConfig): MyPvControllerDto['parameters']['boostConfig'] => {
  return boostConfig.map(boost => {
    const { monday, tuesday, wednesday, thursday, friday, saturday, sunday } = boost.weekDays
    const day = [monday, tuesday, wednesday, thursday, friday, saturday, sunday].map(weekday => (weekday ? '1' : '0')).join(';')
    return {
      day,
      from: getMyPvIoBoostTimeToDto(boost.fromTime),
      to: getMyPvIoBoostTimeToDto(boost.toTime),
      active: false,
      minTempC: boost.securityTemperature || 0,
    }
  })
}
// TODO: Return type is unknown
export const getMyPvPOSTDto = (myPv: MyPvIo): unknown => {
  const { name, pairingId, optimizationMode, boostConfig } = myPv

  return {
    deviceName: name,
    media: 'ModbusTCP',
    type: 'MyPvHeater',
    outputConfiguration: null,
    outputs: [],
    parameters: {
      controlMode: optimizationMode,
      boostConfig: parseMyPvBoostConfigToControllerDtoBoostConfig(boostConfig),
    },
    ...(pairingId
      ? {
          mediaParameters: {
            serialNumber: pairingId,
          },
        }
      : {}),
  }
}

export type MyPvPUTDto = Pick<MyPvControllerDto, 'deviceName' | 'type' | 'outputConfiguration' | 'outputs' | 'inputs'> & {
  parameters: Pick<MyPvControllerDto['parameters'], 'controlMode' | 'boostConfig' | 'inputReadFreq' | 'nominalPower'>
}

export const getMyPvPUTDto = (myPv: MyPvIo): MyPvPUTDto => {
  const { name, pairingId, optimizationMode, boostConfig } = myPv

  return {
    deviceName: name,
    type: 'MyPvHeater',
    parameters: {
      controlMode: optimizationMode,
      boostConfig: parseMyPvBoostConfigToControllerDtoBoostConfig(boostConfig),
      inputReadFreq: 2,
      nominalPower: null,
    },
    outputConfiguration: null,
    outputs: [],
    inputs: [],
    ...(pairingId
      ? {
          mediaParameters: {
            serialNumber: pairingId,
          },
          media: 'ModbusTCP',
        }
      : {}),
  }
}
